<div class="compare-grid visible-mobile">
  <div class="grid-header" unhStickyItem [offset]="55">
    <div class="header-container">
      <h3 class="heading-6 text-center">
        COMMUNITY
        <img src="https://unhide-static-prod.nyc3.cdn.digitaloceanspaces.com/icons/svg/icon-free-rounded.svg" alt="" />
      </h3>
      <h3 class="heading-6 text-center">
        INDIVIDUAL
        <img src="https://unhide-static-prod.nyc3.cdn.digitaloceanspaces.com/icons/svg/icon-pro-rounded.svg" alt="" />
      </h3>
      <h3 class="heading-6 text-center">
        TEAM <img src="https://unhide-static-prod.nyc3.cdn.digitaloceanspaces.com/icons/svg/icon-pro-rounded.svg" alt="" />
      </h3>
    </div>
  </div>

  <div class="grid-body">
    <div class="body-container" *ngFor="let item of membershipPricingMock?.compareGridFeaturesTranslation">
      <p class="title typo-14 mt-0 text-center">
        {{ item.feature }}
      </p>

      <div class="grid-container">
        <div class="text-center" *ngFor="let access of item.access">
          <mat-icon
            svgIcon="unh_checked"
            [ngClass]="{ inactive: access.available == false }"
          ></mat-icon>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="compare-grid visible-desktop">
  <div class="grid-header">
    <div class="grid-container">
      <div></div>
      <h3 class="heading-6 text-center">COMMUNITY
        <img src="https://unhide-static-prod.nyc3.cdn.digitaloceanspaces.com/icons/svg/icon-free-rounded.svg" alt="" />
      </h3>
      <h3 class="heading-6 text-center">INDIVIDUAL
        <img src="https://unhide-static-prod.nyc3.cdn.digitaloceanspaces.com/icons/svg/icon-pro-rounded.svg" alt="" />
      </h3>
      <h3 class="heading-6 text-center">TEAM
        <img src="https://unhide-static-prod.nyc3.cdn.digitaloceanspaces.com/icons/svg/icon-pro-rounded.svg" alt="" />
      </h3>
    </div>
  </div>

  <div class="grid-body">
    <div class="body-container" *ngFor="let item of membershipPricingMock?.compareGridFeaturesTranslation">
      <div class="grid-container">
        <p class="title typo-14 mt-0">
          {{ item.feature }}
        </p>

        <div class="text-center" *ngFor="let access of item.access">
          <mat-icon
            svgIcon="unh_checked"
            [ngClass]="{ inactive: access.available == false }"
          ></mat-icon>
        </div>
      </div>
    </div>
  </div>

  <div class="grid-footer" *ngIf="!ispro">
    <div class="grid-container">
      <div></div>
      <div>
        <a *ngIf="!islogged" mat-button class="unh-button-old" theme="blue-white" href="/signup">
          <p class="btn-label mb-0">{{membershipPricingMock?.compareGridPlansButtonsTranslation[0]?.freePlanButton}}</p>
        </a>
      </div>

      <div>
        <button (click)="actionClicked.emit('pro')" mat-button class="unh-button-old" theme="pink-white">
          <p class="btn-label mb-0">{{membershipPricingMock?.compareGridPlansButtonsTranslation[1]?.individualPlanButton}}</p>
        </button>
      </div>

      <div>
        <button (click)="actionClicked.emit('team')" mat-button class="unh-button-old" theme="pink-white">
          <p class="btn-label mb-0">{{membershipPricingMock?.compareGridPlansButtonsTranslation[2]?.teamPlanButton}}</p>
        </button>
      </div>
    </div>
  </div>
</div>
